import * as React from 'react';
import { api, handleApiError } from 'services/api';

export const useDeleteTrip = () => {
  const deleteTrip = React.useCallback(async (tripId: string | number) => {
    try {
      const url = `/tracking-v2/trips/${tripId}`;
      const { data } = await api.delete<any>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    deleteTrip,
  };
};